import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { SlaCurrencyIcon } from '@/app/landing/sla/shared/components/SlaCurrencyIcon';

type Props = {
  code: string;
};

export function SlaCurrencyLabel({ code }: Props) {
  const { t } = useTranslation('sla');
  const label = t(`currency.${code}`, code);

  return (
    <Flex align="center" gap={8}>
      <SlaCurrencyIcon code={code} size={14} title={label} />
      <span>{label}</span>
    </Flex>
  );
}
